import { Stack, Tabs } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import dayjs from "configs/dayjs";
import { REPORT_TAB, REPORT_TAB_LABEL } from "constants/common/report";
import { ReportParamsType } from "constants/types/common";
import { FC, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CollectionReportTab from "./components/CollectionReportTab/CollectionReportTab";
import ProfitReportTab from "./components/ProfitReportTab/ProfitReportTab";
import PurchaseReportTab from "./components/PurchaseReportTab/PurchaseReportTab";
import ReportFilters from "./components/ReportFilters/ReportFilters";

const REPORT_PAGE_TITLE = "Báo cáo";

const getDefaultParams = (): ReportParamsType => ({
  startDate: dayjs().startOf("month").unix(),
  endDate: dayjs().endOf("month").unix(),
});

const ReportWebLayout: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") ?? REPORT_TAB.PROFIT;
  const [appliedParams, setAppliedParams] = useState<ReportParamsType>(getDefaultParams);

  const handleTabChange = (tab: string | null) => {
    if (!tab) return;
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <Stack gap="sm">
      <PageHeader
        breadcrumbs={[{ title: REPORT_PAGE_TITLE, href: "" }]}
        showDateFilter={false}
      />
      <PageContent>
        <Stack gap="md">
          <ReportFilters onApply={setAppliedParams} activeTab={activeTab} />
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tabs.List>
              <Tabs.Tab value={REPORT_TAB.PROFIT}>
                {REPORT_TAB_LABEL[REPORT_TAB.PROFIT]}
              </Tabs.Tab>
              <Tabs.Tab value={REPORT_TAB.COLLECTION}>
                {REPORT_TAB_LABEL[REPORT_TAB.COLLECTION]}
              </Tabs.Tab>
              <Tabs.Tab value={REPORT_TAB.PURCHASE}>
                {REPORT_TAB_LABEL[REPORT_TAB.PURCHASE]}
              </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value={REPORT_TAB.PROFIT} pt="md">
              <ProfitReportTab params={appliedParams} />
            </Tabs.Panel>
            <Tabs.Panel value={REPORT_TAB.COLLECTION} pt="md">
              <CollectionReportTab params={appliedParams} />
            </Tabs.Panel>
            <Tabs.Panel value={REPORT_TAB.PURCHASE} pt="md">
              <PurchaseReportTab params={appliedParams} />
            </Tabs.Panel>
          </Tabs>
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default ReportWebLayout;
